import React from "react";
import DialButton from "../../../Buttons/DialButton/DialButton";

export default function PhoneNumberCell(cell) {
  return (
    <span style={{display: "flex", alignItems: "center"}}>
      {cell.value ? (
        <DialButton 
          number={cell.value}
        />
      ) : (
        "-"
      )}
    </span>
  );
}